import Vue from 'vue'

export const showToast = function (toastText) {
  Vue.toasted.show(toastText, {
    theme: "toasted-primary",
    position: "top-center",
    duration: 2500
  });
};

export default {
  methods: {
    showToast
  }
};
